import HeaderRight from './HeaderRight';

export default HeaderRight;
